import { lazy } from "react";

// Lazy load all user views
const Home = lazy(() => import("@/views/user/Home"));
const Products = lazy(() => import("@/views/user/Products"));
const ProductDetail = lazy(() => import("@/views/user/ProductDetail"));
const Cart = lazy(() => import("@/views/user/Cart"));
const Checkout = lazy(() => import("@/views/user/Checkout"));
const Profile = lazy(() => import("@/views/user/Profile"));
const Wishlist = lazy(() => import("@/views/user/Wishlist"));
const About = lazy(() => import("@/views/user/About"));
const Contact = lazy(() => import("@/views/user/Contact"));
const Policy = lazy(() => import("@/views/user/Policy"));
const TermsAndConditions = lazy(() => import("@/views/user/TnC"));

/**
 * User Routes Configuration
 * Each route object contains:
 * - path: URL path
 * - element: Component to render
 * - protected: Whether route requires authentication
 * - title: Page title for SEO
 */
export const userRoutes = [
  {
    path: "/",
    element: Home,
    protected: false,
    title: "Home - Makalu Rudraksh",
  },
  {
    path: "/product",
    element: Products,
    protected: false,
    title: "Products - Makalu Rudraksh",
  },
  {
    path: "/product/:categoryId/:subCategoryId",
    element: Products,
    protected: false,
    title: "Products - Makalu Rudraksh",
  },
  {
    path: "/product/:categoryId",
    element: Products,
    protected: false,
    title: "Products - Makalu Rudraksh",
  },
  {
    path: "/product/:categoryId/:subCategoryId/:id",
    element: ProductDetail,
    protected: false,
    title: "Product Details - Makalu Rudraksh",
  },
  {
    path: "/cart",
    element: Cart,
    protected: false,
    title: "Shopping Cart - Makalu Rudraksh",
  },
  {
    path: "/cart/checkout",
    element: Checkout,
    protected: true,
    title: "Checkout - Makalu Rudraksh",
  },
  {
    path: "/my-account/*",
    element: Profile,
    protected: true,
    title: "My Account - Makalu Rudraksh",
  },
  // {
  //   path: "/orders",
  //   element: Orders,
  //   protected: true,
  //   title: "My Orders - Makalu Rudraksh",
  // },
  {
    path: "/wishlist",
    element: Wishlist,
    protected: true,
    title: "Wishlist - Makalu Rudraksh",
  },
  {
    path: "/about",
    element: About,
    protected: false,
    title: "About Us - Makalu Rudraksh",
  },
  {
    path: "/contact",
    element: Contact,
    protected: false,
    title: "Contact Us - Makalu Rudraksh",
  },
  {
    path: "/privacy-policy",
    element: Policy,
    protected: false,
    title: "Privacy Policy - Makalu Rudraksh",
  },
  {
    path: "/terms-of-use",
    element: TermsAndConditions,
    protected: false,
    title: "Terms of Use - Makalu Rudraksh",
  },
];

export default userRoutes;
